import toastr from "toastr";
import i18n from 'i18n';

export const toastrSuccess = (message, operation) => {
  toastr.success(message, operation);
};
export function documentTitleChange (message) {
  return document.title = message === null ? i18n.t('pfPanelTitle') : i18n.t(message);
}
